module.exports = __webpack_public_path__ + "static/img/naniungo-slide-19.ce824ee6.jpg";